module.exports = __webpack_public_path__ + "static/img/编组11.0ffb059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/编组11.png
// module id = WKyk
// module chunks = 1